import { IncentiveOfferStatus } from 'modules/incentivesMarket/types';

type IncentiveOfferStatusConfig = {
  label: string;
  value: IncentiveOfferStatus;
  fill: string;
  style: string;
  badge: string;
  icon: string;
};

const incentiveOfferStatus: Record<IncentiveOfferStatus, IncentiveOfferStatusConfig> =
  {
    DRAFT: {
      label: 'Draft',
      value: IncentiveOfferStatus.DRAFT,
      style: 'text-light',
      badge: 'badge badge-outline badge-light',
      fill: 'bg-light',
      icon: 'ni-draft',
    },
    PENDING: {
      label: 'Pending',
      value: IncentiveOfferStatus.PENDING,
      style: 'text-primary',
      badge: 'badge badge-outline badge-primary',
      fill: 'bg-primary',
      icon: 'ni-clock',
    },
    CANCELED: {
      label: 'Canceled',
      value: IncentiveOfferStatus.CANCELED,
      style: 'text-danger',
      badge: 'badge badge-outline badge-danger',
      fill: 'bg-danger',
      icon: 'ni-cross-circle',
    },
    ACTIVE: {
      label: 'Active',
      value: IncentiveOfferStatus.ACTIVE,
      style: 'text-primary',
      badge: 'badge badge-outline badge-primary',
      fill: 'bg-primary',
      icon: 'ni-activity',
    },
    ACCEPTED: {
      label: 'Accepted',
      value: IncentiveOfferStatus.ACCEPTED,
      style: 'text-info',
      badge: 'badge badge-outline badge-info',
      fill: 'bg-info',
      icon: 'ni-check-circle',
    },
    REJECTED: {
      label: 'Rejected',
      value: IncentiveOfferStatus.REJECTED,
      style: 'text-danger',
      badge: 'badge badge-outline badge-danger',
      fill: 'bg-danger',
      icon: 'ni-cross-circle',
    },
    EXPIRED: {
      label: 'Expired',
      value: IncentiveOfferStatus.EXPIRED,
      style: 'text-secondary',
      badge: 'badge badge-outline badge-secondary',
      fill: 'bg-secondary',
      icon: 'ni-clock',
    },
  };

export default incentiveOfferStatus;
